import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { css } from 'styled-components';
import { colorGrey30, colorGrey50, colorGrey60 } from '../../../../tokens';
export var getPageNavigationOverride = function getPageNavigationOverride() {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        .PageNavigation-ArrowButton[data-disabled=''] {\n            color: ", ";\n        }\n        .PageNavigation-ArrowButton[data-disabled='1'] {\n            color: ", ";\n        }\n\n        .PageNavigation-PageButton[data-disabled=''] {\n            &:hover {\n                background-color: ", ";\n            }\n        }\n    "])), colorGrey30, colorGrey50, colorGrey60);
};